export default {
  password: "auth/set-password",
  notification: "auth/notification",
  companies: "company/companies",
  getRegistrations: "student/programme-registration",
  intakePeriods: "setup/intakePeriod",
  balance: (id) => `student/getBalance?profileNo=${id}`,
  getStudentAmountToPay: (params) =>
    `student/getStudentAmountToPay?profileNo=${params.profileNo}&billAmount=${params.amount}`,
  ACCREDITEDINSTITUTE: "setup/accreditedInstitute",
  examCenters: "setup/exam-centers",
  settings: "admin/settings",
};
